
import React from "react";

/**
 * NotFound component – displays a friendly 404 page.
 *
 * The component is defined once and exported both as a named export
 * and as the default export to avoid duplicate export errors.
 */
export const NotFound: React.FC = () => {
  try {
    return (
      <div className="flex flex-col items-center justify-center h-screen text-center px-4">
        <h1 className="text-5xl md:text-5xl font-semibold text-gray-100">404</h1>
        <h1 className="text-2xl md:text-3xl font-semibold mt-6">
          This page has not been generated
        </h1>
        <p className="mt-4 text-xl md:text-2xl text-gray-500">
          Tell me what you would like on this page
        </p>
      </div>
    );
  } catch (error) {
    // In the unlikely event something goes wrong while rendering,
    // fall back to a minimal error message to avoid breaking the whole UI.
    console.error("Error rendering NotFound component:", error);
    return (
      <div className="flex items-center justify-center h-screen text-center px-4">
        <p className="text-red-500">An unexpected error occurred.</p>
      </div>
    );
  }
};

export default NotFound;
